import { useIntl } from 'react-intl';
const useMultiLanguageEnterpriseLog = () => {
  const intl = useIntl();
  const ENTERPRISE_LOG_LIST_TITLE = intl.formatMessage({
    id: 'authentication.enterpriseLogList.title',
  });
  const ENTERPRISE_LOG_LIST_PLACEHOLDER_SEARCH = intl.formatMessage({
    id: 'authentication.enterpriseLogList.placeholderSearch',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.accountAccessRanking.pageTitle',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.accountAccessRanking.productName',
  });
  const ACCOUNT_ACCESS_RANKING_TABLE_COUNT = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.accountAccessRanking.count',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_ID = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.fileDownloadRanking.id',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_URL = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.fileDownloadRanking.url',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.fileDownloadRanking.detailTitle',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.fileDownloadRanking.productName',
  });
  const FILE_DOWNLOAD_RANKING_TABLE_COUNT = intl.formatMessage({
    id: 'authentication.enterpriseLogList.table.fileDownloadRanking.count',
  });
  return {
    ENTERPRISE_LOG_LIST_TITLE,
    ENTERPRISE_LOG_LIST_PLACEHOLDER_SEARCH,
    ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE,
    ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME,
    ACCOUNT_ACCESS_RANKING_TABLE_COUNT,
    FILE_DOWNLOAD_RANKING_TABLE_ID,
    FILE_DOWNLOAD_RANKING_TABLE_URL,
    FILE_DOWNLOAD_RANKING_TABLE_DETAIL_TITLE,
    FILE_DOWNLOAD_RANKING_TABLE_PRODUCT_NAME,
    FILE_DOWNLOAD_RANKING_TABLE_COUNT,
  };
};
export default useMultiLanguageEnterpriseLog;
